module.exports = __webpack_public_path__ + "img/C03TechChampionChampion_ua.64098d5d.webp";